import {OpenAPI} from './openapi';

export const MAINTENANCE_DETAIL = 'MAINTENANCE_MODE_ACTIVE';

export const isMaintenanceError = (err: any): boolean =>
  err?.status === 503 && err?.body?.detail === MAINTENANCE_DETAIL;

export const fetchMaintenanceStatus = async (): Promise<boolean> => {
  try {
    const res = await fetch(`${OpenAPI.BASE}/public/maintenance`);
    if (!res.ok) return false;
    const data = await res.json();
    return data?.maintenance === true;
  } catch {
    return false;
  }
};
